export default __webpack_public_path__ + "static/media/slider-3.5bfb12a2.png";